import {
  betslipValidation,
  removeSelected,
  resetStateBetslip,
  setMatchBetslip,
  setSelected,
} from "../../redux/bettingSlice";
import { resetState } from "../../redux/matchesSlice";
import { addToSlip, clear_rep, clearSlip, getBetslip } from "./betslip";
import { setLocalStorage } from "./local-storage";

export const handleRemoveExpired = (dispatch) => {
  // Get betslips from local storage or state
  let betslips = getBetslip() || [];

  // Filter out items with disabled set to true
  const updatedBetslip = Object.fromEntries(
    Object.entries(betslips).filter(([key, slipdata]) => !slipdata.disable)
  );

  // Iterate over the updated betslip to reset state and remove selected items
  Object.entries(betslips).forEach(([key, slipdata]) => {
    if (slipdata.disable) {
      let match_selector = slipdata.parent_match_id + "_selected";
      dispatch(resetStateBetslip("betslip"));
      dispatch(removeSelected(match_selector));
    }
  });

  // Update the local storage with the filtered betslip
  setLocalStorage("betslip", updatedBetslip);

  // Prepare betslip data for dispatch
  const betslip_data = {
    betslip_type: "betslip",
    data: updatedBetslip,
  };

  // Dispatch updated betslip to Redux store
  dispatch(setMatchBetslip(betslip_data));
};

export const handleBetslipUpdate = (decodedMatches, actionType, dispatch) => {
  if (actionType === "clear") {
    let betslips = getBetslip();
    Object.entries(betslips).forEach(([match_id, match]) => {
      let match_selector = match.parent_match_id + "_selected";
      dispatch(removeSelected(match_selector));
    });
    clearSlip();
    dispatch(resetStateBetslip("betslip"));
  }
  let betslip;
  Object.entries(decodedMatches).forEach(([match_id, match]) => {
    let reference = match.parent_match_id + "_selected";
    let cstm = clear_rep(
      match.parent_match_id + "" + match.sub_type_id + match.outcome_id
    );
    //   match.live = Number(match?.live) !== 0;
    //   match.bet_type = String(match?.bet_type);
    betslip = addToSlip(match);
    dispatch(setSelected(reference, cstm));
  });
  const betslip_data = {
    betslip_type: "betslip",
    data: betslip,
  };
  dispatch(setMatchBetslip(betslip_data));

  dispatch(
    betslipValidation({
      endpoint: "v2/betslip-validation",
      method: "POST",
      data: betslip,
      payload: betslip,
    })
  );

  dispatch(resetState("decoded_match"));
};
